import {
  type DatabaseDiscoveryUpdateDetail,
  getDatabaseDiscoveryKey,
  type WorkspaceDatabaseInfo,
} from './database-discovery-bridge';

function getDiscoveryFingerprint(database: WorkspaceDatabaseInfo): string {
  return JSON.stringify({
    databaseTitle: database.databaseTitle,
    docTitle: database.docTitle,
    isInTrash: database.isInTrash,
    visible: database.visible,
    columns: database.columns,
  });
}

export function getDatabaseSnapshot(databases: WorkspaceDatabaseInfo[]) {
  return new Map(
    databases.map(database => [
      getDatabaseDiscoveryKey(database),
      {
        blockId: database.blockId,
        fingerprint: getDiscoveryFingerprint(database),
      },
    ])
  );
}

export function getDiscoveryUpdateDetail(
  previous: Map<string, { blockId: string; fingerprint: string }>,
  next: Map<string, { blockId: string; fingerprint: string }>
): DatabaseDiscoveryUpdateDetail {
  const affectedDatabaseKeys = new Set<string>();
  const affectedDatabaseIds = new Set<string>();

  for (const [key, database] of next) {
    if (previous.get(key)?.fingerprint !== database.fingerprint) {
      affectedDatabaseKeys.add(key);
      affectedDatabaseIds.add(database.blockId);
    }
  }

  for (const [key, database] of previous) {
    if (!next.has(key)) {
      affectedDatabaseKeys.add(key);
      affectedDatabaseIds.add(database.blockId);
    }
  }

  return {
    affectedDatabaseKeys: Array.from(affectedDatabaseKeys),
    affectedDatabaseIds: Array.from(affectedDatabaseIds),
  };
}
